// Toolbox
export const HEADER_HEIGHT_PX = 56;

// Stage
export const NAV_ARROW_HEIGHT_PX = 112;
export const PLENARY_STAGE_WIDTH_PX = 1280;
export const PLENARY_STAGE_HEIGHT_PX = 720;
export const PLENARY_HEADER_HEIGHT_PX = 48;

export const STUDIO_MAIN_SECTION_PADDING_TOP_PX = 80;
export const PLAYER_MAIN_SECTION_PADDING_TOP_PX = 24;
export const STAGE_SECTION_PADDING_PX = 24;
export const STAGE_SECTION_AFTER_PADDING_BOTTOM_PX = 96;

/// General
export const BASIC_BORDER_RADIUS = 8;
